<template>
	<div class="page">
		<top-header></top-header>
		<div class="cont-box">
		<b-container fluid style="margin-top:5%;">
			<!-- <b-row class="">
				<b-col>
					<b-card img-src="../assets/dcu.svg" img-alt="Card image" img-left class="info-box mb-3">
						<h6>Total CCMS</h6>
						<b-card-text>
							{{records.length}}
						</b-card-text>
					</b-card>
				</b-col>
				<b-col>
					<b-card img-src="../assets/dcu.svg" img-alt="Card image" img-left class="info-box mb-3">
						<h6>CCMS Connected</h6>
						<b-card-text>
							{{ device_connected }} <small>Nos</small>
						</b-card-text>
					</b-card>
					
				</b-col>
				<b-col>
					<b-card img-src="../assets/dcu.svg" img-alt="Card image" img-left class="info-box mb-3 bg-orange">
						<h6>Temp. Signal Loss (CCMS)</h6>
						<b-card-text>
							{{ records.length - device_connected }} <small>Nos</small>
						</b-card-text>
					</b-card>
				</b-col>
				<b-col>
					<b-card img-src="../assets/dcu.svg" img-alt="Card image" img-left class="info-box mb-3 bg-green">
						<h6>CCMS ON</h6>
						<b-card-text>
							{{ device_on }} <small>Nos</small>
						</b-card-text>
					</b-card>
					
				</b-col>
				<b-col>
					<b-card img-src="../assets/dcu.svg" img-alt="Card image" img-left class="info-box mb-3 bg-red">
						<h6>CCMS OFF</h6>
						<b-card-text>
							{{ device_connected - device_on}} <small>Nos</small>
						</b-card-text>
					</b-card>
				</b-col> -->
				<!--<b-col>
					<b-card img-src="../assets/electric.svg" img-alt="Card image" img-left class="info-box mb-3">
						<h6>Total Load</h6>
						<b-card-text>
							{{ $root.tofixed(total_load / 1000 , 3) }} <small>KW</small>
						</b-card-text>
					</b-card>
				</b-col>
				<b-col>
					<b-card img-src="../assets/electric.svg" img-alt="Card image" img-left class="info-box mb-3">
						<h6>Current Load</h6>
						<b-card-text>
							{{current_load/100000}} <small>KW</small>
						</b-card-text>
					</b-card>
				</b-col>-->
			<!-- 	</b-row> -->
			<!-- <b-row>
				<b-col>
					<b-card img-src="../assets/street-light.svg" img-alt="Card image" img-left class="info-box mb-3">
						<h6>Total Lights</h6>
						<b-card-text>
							{{total_lights}}
						</b-card-text>
					</b-card>
				</b-col>
				<b-col>
					<b-card img-src="../assets/light-on.svg" img-alt="Card image" img-left class="info-box mb-3 bg-green">
						<h6>Total Light ON</h6>
						<b-card-text>
							{{total_light_on}} <small>({{ $root.tofixed((total_light_on/total_lights)*100, 2) }}%)</small>
						</b-card-text>
					</b-card>
				</b-col>
				<b-col>
					<b-card img-src="../assets/light-off.svg" img-alt="Card image" img-left class="info-box mb-3 bg-red">
						<h6>Total Light OFF</h6>
						<b-card-text>
							{{total_light_off}} <small>({{ $root.tofixed((total_light_off/total_lights)*100, 2) }}%)</small>
						</b-card-text>
					</b-card>
				</b-col>
				<b-col>
					<b-card img-src="../assets/no-light.svg" img-alt="Card image" img-left class="info-box mb-3 bg-orange">
						<h6>Temp. Signal Loss (Light)</h6>
						<b-card-text>
							{{total_signal_loss}} <small>({{ $root.tofixed((total_signal_loss/total_lights)*100, 2) }}%)</small>
						</b-card-text>
					</b-card>
				</b-col>
				<b-col>
					<b-card img-src="../assets/electric.svg" img-alt="Card image" img-left class="info-box mb-3">
						<h6>Total Consumption</h6>
						<b-card-text>
							{{$root.tofixed(total_kwh/100, 2)}} <small>KWH</small>
						</b-card-text>
					</b-card>
				</b-col>
			</b-row> -->
           <!--  <b-row class="mb-3">
                <b-col class="col-md-3">
                    <label>State</label>
                    <b-form-select v-model="filter_state_id" :options="$root.state_options" @change="filter_zone_id=0; filter_ulb_id=0" required></b-form-select>
                </b-col>
                <b-col class="col-md-3">
                    <label>Zone</label>
                    <b-form-select v-model="filter_zone_id">
                        <b-form-select-option value="0">--- Select Zone ---</b-form-select-option>
                        <b-form-select-option v-for="item in filterZoneDevices(zoneOptions)" v-bind:key="item.id" :value="item.id" @change="filter_ulb_id=0">{{item.title}}</b-form-select-option>
                    </b-form-select>
                </b-col>
                <b-col class="col-md-3">
                   <label>ULB</label>
                    <b-form-select v-model="filter_ulb_id">
                        <b-form-select-option value="0">--- Select ULB ---</b-form-select-option>
                        <b-form-select-option v-for="item in filterULBDevices(zoneOptions)" v-bind:key="item.id" :value="item.id" >{{item.title}}</b-form-select-option>
                    </b-form-select>
                </b-col>
                <b-col class="col-md-3">
                    <label>.</label>
                    <b-button pill variant="primary" class="mr-1" @click="initload()" size="sm">Submit</b-button>
                </b-col>
            </b-row> -->
			<b-row class="mb-2" v-if="filteredrecords.length > 0 && $root.chkperm('broadcast','enabled')">
				<b-col>
					<b-button size="sm" class="mr-2" variant="success" @click="broadcastSMS('LIGHTON')">LIGHT ON</b-button>
					<b-button size="sm" class="mr-2" variant="danger" @click="broadcastSMS('LIGHTOFF')">LIGHT OFF</b-button>
					<b-button size="sm" class="mr-2" variant="warning" @click="broadcastSMS('DEFAULT')">SET DEFAULT</b-button>
					<b-button size="sm" class="mr-2" variant="info" @click="broadcastSMS('IPADDR,216.10.251.190,32212')">SET IP (32212)</b-button>
					<b-button size="sm" class="mr-2" variant="info" @click="broadcastRTC(selectedItem.mobile_no)">SET RTC ({{nowTime}})</b-button>
					<b-form inline>
						<label>On Timing</label>
						<b-input-group>
							<b-form-input id="on-time-input" v-model="on_time" type="text" size="sm" placeholder="HH:MM"></b-form-input>
						</b-input-group>
						<label>Off Timing</label>
						<b-input-group>
							<b-form-input id="on-time-input" v-model="off_time" type="text" size="sm" placeholder="HH:MM"></b-form-input>
						</b-input-group>
					</b-form>
				</b-col>
				<b-col>
					<b-button size="sm" class="mr-2" variant="info" @click="broadcastSchedule(selectedItem.mobile_no)">SET SCHEDULE</b-button>
				</b-col>
			</b-row>
			<b-row>
				<b-col class="col-md-12 col-sm-12 col-xs-12">
					<div class="container-box">
						<b-row class="mt-4 px-3">
							<b-col lg="4">
								<span class="mr-2">Show</span>
								<b-form-select v-model="perPage" id="perPageSelect" :options="pageOptions" size="sm" class="w-25">
								</b-form-select>
								<span class="ml-2">entries</span>
							</b-col>
							<b-col lg="4">
								<span class="mr-2">Network Filter</span>
								<b-form-select v-model="networkfilter" :options="networkOptions" size="sm" class="w-25" @change="onFilterDevices()">
								</b-form-select>
								<span class="ml-4 mr-2">Power Filter</span>
								<b-form-select v-model="powerfilter" :options="powerOptions" size="sm" class="w-25" @change="onFilterDevices()">
								</b-form-select>
							</b-col>
							<b-col lg="4">
								<b-form-group label="Filter" label-cols-sm="3" label-align-sm="right" label-size="sm" label-for="filterInput" class="mb-0">
									<b-input-group size="sm">
										<b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search">
										</b-form-input>
										<b-input-group-append>
											<b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
										</b-input-group-append>
									</b-input-group>
								</b-form-group>
							</b-col>
						</b-row>
						<b-row class="px-3 pt-3">
							<b-col lg="12">
								<b-table show-empty sticky-header small striped outlined id="my-table" stacked="md" :items="filteredrecords" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :filterIncludedFields="filterOn" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered">
									<template v-slot:cell(no_of_fittings)="row">
										<a :href="'/controllers/'+row.item.feeder_pillar_no" v-if="row.item.connections > 0"><b-badge pill variant="success">{{row.item.connections}}</b-badge></a>
										<b-badge pill variant="success" v-else>{{row.item.no_of_fittings}}</b-badge>
									</template>
									<template v-slot:cell(maintenance)="row">
										<b-badge pill variant="warning" v-if="row.value == 1">YES</b-badge>
										<b-badge pill variant="secondary" v-else>NO</b-badge>
									</template>
									<template v-slot:cell(door_status)="row">
										<b-badge pill variant="danger" v-if="row.value == 1">OPENED</b-badge>
										<b-badge pill variant="success" v-else>CLOSED</b-badge>
									</template>
									<template v-slot:cell(supply)="row">
										<img src="../assets/power-on.svg" v-if="row.value == 'ON'" style="max-width:20px; max-height:20px;">
										<img src="../assets/power-off.svg" v-else style="max-width:20px; max-height:20px;">
									</template>
									<template v-slot:cell(feeder_pillar_no)="row">
										<b-link :href="'/device-data/'+row.item.imei_no">{{row.value}}</b-link>
									</template>
									<template v-slot:cell(connection_status)="row">
										<b-link :href="'/device-fault/'+row.item.imei_no" v-if="row.value == 2"><div><b-badge pill variant="warning">DATA FAULT</b-badge></div></b-link>
										<b-badge pill variant="danger" v-else-if="row.value == 0">DISCONNECTED</b-badge>
										<b-badge pill variant="success" v-else>CONNECTED</b-badge>
									</template>
									<template v-slot:cell(actions)="row">
										<b-button pill variant="primary" class="mr-1 pt-1 icon-btn" v-if="$root.chkperm('master_devices','sms')" @click="showSMSModal(row.item, row.index, $event.target)" size="sm"><b-icon icon="envelope" font-scale="1.5" ></b-icon></b-button>
										<b-button pill variant="primary" class="mr-1 pt-1 icon-btn" v-if="$root.chkperm('master_devices','replace')" @click="showReplaceModal(row.item, row.index, $event.target)" size="sm"><b-icon icon="gear-fill" font-scale="1.5" ></b-icon></b-button>
										<b-button pill variant="info" class="mr-1 pt-1 icon-btn" v-if="$root.chkperm('master_devices','view')" @click="showViewModal(row.item, $event.target)" size="sm"><b-icon icon="search" font-scale="1.5" ></b-icon></b-button>
										<b-button pill variant="primary" class="mr-1 pt-1 icon-btn" v-if="$root.chkperm('master_devices','edit')" @click="showUpdateModal(row.item, row.index, $event.target)" size="sm"><b-icon icon="pencil" font-scale="1.5" ></b-icon></b-button>
										<b-button pill variant="danger" class="mr-1 pt-1 icon-btn" v-if="$root.chkperm('master_devices','delete')" @click="showDeleteModal(row.item)" size="sm"><b-icon icon="trash" font-scale="1.5" ></b-icon></b-button>
									</template>
								</b-table>
							</b-col>
						</b-row>
						<b-row class="px-3">
							<b-col lg="6">
								<span class="mr-2">Showing {{currentPage}} to {{(perPage>filteredrecords.length)?filteredrecords.length:perPage}} of {{filteredrecords.length}} entries</span>
							</b-col>
							<b-col lg="3" offset-md="3">
								<b-pagination v-model="currentPage" pills :total-rows="totalRows" :per-page="perPage" align="right" size="sm" prev-text="Prev" next-text="Next" first-number last-number></b-pagination>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>
			<b-container fluid style="display:none">
				<b-row class="my-3">
					<b-col md="12">
						<line-chart ref="livechart" height="100"/>
					</b-col>
				</b-row>
			</b-container>
			<b-modal id="view-model" title="View DCU" ok-only @hide="setMaintenance">
				<b-container fluid>
					<b-row class="mb-1r">
						<b-col cols="4" class="text-right">IMEI :</b-col>
						<b-col cols="8">{{selectedItem.imei_no}}</b-col>
					</b-row>
					<b-row class="mb-1r">
						<b-col cols="4" class="text-right">Zone :</b-col>
						<b-col cols="8">{{selectedItem.ulb_id}}</b-col>
					</b-row>
					<b-row class="mb-1r">
						<b-col cols="4" class="text-right">Feeder Pillor No :</b-col>
						<b-col cols="8">{{selectedItem.feeder_pillar_no}}</b-col>
					</b-row>
					<b-row class="mb-1r">
						<b-col cols="4" class="text-right">Ward No :</b-col>
						<b-col cols="8">{{selectedItem.ward_no}}</b-col>
					</b-row>
				</b-container>
				<template v-slot:modal-footer="{ ok, close, hide }">
					<div v-if="$root.chkperm('page_devices','maintenance')">
						<b-button size="sm" variant="warning" v-if="selectedItem.maintenance == 0" @click="hide('maintenance_on')">Maintenance ON</b-button>
						<b-button size="sm" variant="warning" v-else @click="hide('maintenance_off')">Maintenance OFF</b-button>
					</div>
					<b-button size="sm" variant="danger" @click="close()">Cancel</b-button>
					<b-button size="sm" variant="success" @click="ok()">Ok</b-button>
				</template>
			</b-modal>
			
            <b-modal id="sms-model" title="SMS" close-only>
				<b-container fluid>
					<b-row class="mb-1r">
						<b-col cols="4" class="pl-0 pr-1"><b-button size="sm" class="w-100" variant="success" @click="sendSMS(selectedItem.mobile_no,'LIGHTON')">LIGHT ON</b-button></b-col>
                        <b-col cols="4" class="pl-1 pr-1"><b-button size="sm" class="w-100" variant="danger" @click="sendSMS(selectedItem.mobile_no,'LIGHTOFF')">LIGHT OFF</b-button></b-col>
                        <b-col cols="4" class="pl-1 pr-1"><b-button size="sm" class="w-100" variant="warning" @click="sendSMS(selectedItem.mobile_no,'DEFAULT')">SET DEFAULT</b-button></b-col>
					</b-row>
					<b-row class="mb-1r mt-2">
						<b-col cols="6" class="pl-0 pr-1"><b-button size="sm" class="w-100" variant="info" @click="sendSMS(selectedItem.mobile_no,'IPADDR,216.10.251.190,32212')">SET IP (32212)</b-button></b-col>
						<b-col cols="6" class="pl-1 pr-1"><b-button size="sm" class="w-100" variant="info" @click="setRTC(selectedItem.mobile_no)">SET RTC ({{nowTime}})</b-button></b-col>
					</b-row>
				</b-container>
			</b-modal>

			<b-modal id="replace-model" title="Replace Panel" size="lg" ok-only @hidden="resetSelectedItem" @ok="onReplaceDevice">
				<b-container fluid>
					<b-row class="mb-1">
						<b-col>
							<b-alert show variant="secondary" class="header-title">Device Information</b-alert>
							<b-form-group label="Imei" label-for="imei-input" label-cols="4" label-size="sm" label-align-sm="right" invalid-feedback="Imei is required">
								<b-form-input id="imei-input" v-model="replaceItem.replace_imei_no" disabled></b-form-input>
							</b-form-group>
							<b-form-group label="Feeder Piller No" label-for="fp-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="fp-input" v-model="replaceItem.feeder_pillar_no" disabled></b-form-input>
							</b-form-group>
							<b-form-group label="Meter No" label-for="ccms-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="ccms-input" v-model="replaceItem.replace_meter_no" disabled></b-form-input>
							</b-form-group>
							<b-form-group label="Mobile No" label-for="ccms-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="mobile-input" v-model="replaceItem.mobile_no" disabled></b-form-input>
							</b-form-group>
						</b-col>
						<b-col>
							<b-alert show variant="secondary" class="header-title">Replace Information</b-alert>
							<b-form-group label="New CCMS" label-for="fp-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="location-input" v-model="replaceItem.new_imei_no" placeholder="New Imei no."></b-form-input>
							</b-form-group>
							<b-form-group label="New Meter" label-for="ward-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="location-input" v-model="replaceItem.new_meter_no" placeholder="New Meter no."></b-form-input>
							</b-form-group>
							<b-form-group label="Replace Date" label-for="ward-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-datepicker id="ward-input" v-model="replaceItem.replace_time" :date-format-options="{ year: 'numeric', month: 'long', day: '2-digit' }" required></b-form-datepicker>
							</b-form-group>
						</b-col>
					</b-row>
				</b-container>
				<form ref="form" @submit.stop.prevent="handleSubmit">
					
				</form>
				<template v-slot:modal-footer="{ ok, close }">
					<b-button size="sm" variant="danger" @click="close()">Cancel</b-button>
					<b-button size="sm" variant="success" @click="ok()">{{(selectedItem.id > 0)?'Update':'Submit'}}</b-button>
				</template>
			</b-modal>
			
			<b-modal id="edit-model" :title="(selectedItem.id > 0)?'Edit CCMS | DCU':'Add CCMS | DCU'" size="xl" ok-only @hidden="resetSelectedItem" @ok="modalSubmit">
				<b-container fluid>
					<b-row class="mb-1">
						<b-col>
								<div class="panel-new">
									<h4>Device Information</h4>
									<b-form-group label-for="imei-input" label-cols="0" label-size="sm" label-align-sm="left" invalid-feedback="Imei is required" inline="true">
										<label>Imei</label>
										<b-form-input id="imei-input" v-model="selectedItem.imei_no" :disabled="selectedItem.id > 0" required></b-form-input>
									</b-form-group>
									<b-form-group label="Feeder Piller No" label-for="fp-input" label-cols="0" label-size="sm" label-align-sm="left">
										<b-form-input id="fp-input" v-model="selectedItem.feeder_pillar_no" :disabled="selectedItem.id > 0" required></b-form-input>
									</b-form-group>
									<b-form-group label="Pole No" label-for="fp-ploe_no" label-cols="0" label-size="sm" label-align-sm="left" >
										<div class="d-flex">
										<b-form-input id="fp-ploe_no" v-model="selectedItem.ploe_no_start"  required style="width:40%;"></b-form-input> <span style="margin: 5px 10px;">To </span>
										<b-form-input id="fp-ploe_no_end" v-model="selectedItem.ploe_no_end"  required style="width:40%;"></b-form-input> 
									</div>
										

									</b-form-group>
									<b-form-group label="Device Type" label-for="title" label-cols="0" label-size="sm" label-align-sm="left">
										<b-form-select v-model="selectedItem.device_type" disabled>
											<b-form-select-option value="CCMS">CCMS</b-form-select-option>
											<b-form-select-option value="DCU">DCU</b-form-select-option>
										</b-form-select>
									</b-form-group>
									<b-form-group label="Meter Type" label-for="title" label-cols="0" label-size="sm" label-align-sm="left">
										<b-form-select v-model="selectedItem.meter_type">
											<b-form-select-option value="3P">3 Phase</b-form-select-option>
											<b-form-select-option value="1P">1 Phase</b-form-select-option>
										</b-form-select>
									</b-form-group>
									<b-form-group label="Modem Type" label-for="title" label-cols="0" label-size="sm" label-align-sm="left">
										<b-form-select v-model="selectedItem.modem_type" disabled>
											<b-form-select-option value="2G">2G</b-form-select-option>
											<b-form-select-option value="4G">4G</b-form-select-option>
										</b-form-select>
									</b-form-group>
									<b-form-group label="Inst. Phase" label-for="title" label-cols="0" label-size="sm" label-align-sm="left">
										<b-form-select v-model="selectedItem.phase">
											<b-form-select-option value="1">Phase 1</b-form-select-option>
											<b-form-select-option value="2">Phase 2</b-form-select-option>
										</b-form-select>
									</b-form-group>
									<b-form-group label="Vendor" label-for="title" label-cols="0" label-size="sm" label-align-sm="left">
										<b-form-select v-model="selectedItem.vendor">
											<b-form-select-option value="1">Matrix</b-form-select-option>
											<b-form-select-option value="2">Horizon</b-form-select-option>
										</b-form-select>
									</b-form-group>
									<b-form-group label="Meter No" label-for="ccms-input" label-cols="0" label-size="sm" label-align-sm="left">
										<b-form-input id="ccms-input" v-model="selectedItem.device_no" :disabled="selectedItem.id > 0" required></b-form-input>
									</b-form-group>
									<b-form-group label="Mobile No" label-for="ccms-input" label-cols="0" label-size="sm" label-align-sm="left">
										<b-form-input id="mobile-input" v-model="selectedItem.mobile_no" required></b-form-input>
									</b-form-group>
									<b-form-group label="Consumer No" label-for="consumer-input" label-cols="0" label-size="sm" label-align-sm="left">
										<b-form-input id="consumer-input" v-model="selectedItem.consumer_no" required></b-form-input>
									</b-form-group>
								</div>
							</b-col>

								
						<b-col>
							<div class="panel-new panel-new-2">
							<h4>Location Information</h4>
							<b-form-group label="State" label-for="fp-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-select v-model="selectedItem.state_id" :options="$root.state_options" @change="selectedItem.zone_id=0; selectedItem.ulb_id=0" required></b-form-select>
							</b-form-group>
							<b-form-group label="Zone" label-for="title" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-select v-model="selectedItem.zone_id">
									<b-form-select-option value="0">--- Select Zone ---</b-form-select-option>
									<b-form-select-option v-for="item in filterZone(zoneOptions)" v-bind:key="item.id" :value="item.id" @change="selectedItem.ulb_id=0">{{item.title}}</b-form-select-option>
								</b-form-select>
							</b-form-group>
							<b-form-group label="ULB" label-for="title" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-select v-model="selectedItem.ulb_id">
									<b-form-select-option value="0">--- Select ULB ---</b-form-select-option>
									<b-form-select-option v-for="item in filterULB(zoneOptions)" v-bind:key="item.id" :value="item.id" >{{item.title}}</b-form-select-option>
								</b-form-select>
							</b-form-group>
							<b-form-group label="Location" label-for="ward-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="location-input" v-model="selectedItem.location" required></b-form-input>
							</b-form-group>
							<b-form-group label="Ward No" label-for="ward-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="ward-input" v-model="selectedItem.ward_no" required></b-form-input>
							</b-form-group>
							
							<b-form-group label="Previous Load" label-for="prev-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="prevload-input" v-model="selectedItem.previous_load" required></b-form-input>
							</b-form-group>
							<b-form-group label="Total Load" label-for="load-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="load-input" v-model="selectedItem.total_load" required></b-form-input>
							</b-form-group>
							
							
							<b-form-group label="No of Fittings" label-for="fitting-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="fitting-input" v-model="selectedItem.no_of_fittings" required></b-form-input>
							</b-form-group>
							</div>
						</b-col>
						
						<b-col >
							<div class="panel-new panel-new-3">
										<h4>LED Information</h4>
							
							<b-row>
								<b-col class="pr-0">
									<b-form-group label="18W" label-cols="6" label-size="sm" label-align-sm="right">
										<b-form-input v-model="selectedItem.led_18w" @change="updateTotalLoad"></b-form-input>
									</b-form-group>
								</b-col>
								<b-col class="pl-0">
									<b-form-group label="24W" label-cols="6" label-size="sm" label-align-sm="right">
										<b-form-input v-model="selectedItem.led_24w" @change="updateTotalLoad"></b-form-input>
									</b-form-group>
								</b-col>
							</b-row>
							<b-row>
								<b-col class="pr-0">
									<b-form-group label="35W" label-cols="6" label-size="sm" label-align-sm="right">
										<b-form-input v-model="selectedItem.led_35w" @change="updateTotalLoad"></b-form-input>
									</b-form-group>
								</b-col>
								<b-col class="pl-0">
									<b-form-group label="45W" label-cols="6" label-size="sm" label-align-sm="right">
										<b-form-input v-model="selectedItem.led_45w" @change="updateTotalLoad"></b-form-input>
									</b-form-group>
								</b-col>
							</b-row>
							<b-row>
								<b-col class="pr-0">
									<b-form-group label="70W" label-cols="6" label-size="sm" label-align-sm="right">
										<b-form-input v-model="selectedItem.led_70w" @change="updateTotalLoad"></b-form-input>
									</b-form-group>
								</b-col>
								<b-col class="pl-0">
									<b-form-group label="75W" label-cols="6" label-size="sm" label-align-sm="right">
										<b-form-input v-model="selectedItem.led_75w" @change="updateTotalLoad"></b-form-input>
									</b-form-group>
								</b-col>
							</b-row>
							<b-row>
								<b-col class="pr-0">
									<b-form-group label="110W" label-cols="6" label-size="sm" label-align-sm="right">
										<b-form-input v-model="selectedItem.led_110w" @change="updateTotalLoad"></b-form-input>
									</b-form-group>
								</b-col>
								<b-col class="pl-0">
									<b-form-group label="140W" label-cols="6" label-size="sm" label-align-sm="right">
										<b-form-input v-model="selectedItem.led_140w" @change="updateTotalLoad"></b-form-input>
									</b-form-group>
								</b-col>
							</b-row>
							<b-row>
								<b-col class="pr-0">
									<b-form-group label="190W" label-cols="6" label-size="sm" label-align-sm="right">
										<b-form-input v-model="selectedItem.led_190w" @change="updateTotalLoad"></b-form-input>
									</b-form-group>
								</b-col>
								<b-col class="pl-0">
								</b-col>
							</b-row>
							</div>
						</b-col>
						<b-col >
						<div class="panel-new panel-new-4">
							<h4>Map Information</h4>
							<b-form-group label="Latitude" label-for="load-input" label-cols="0" label-size="sm" label-align-sm="left">
								<b-form-input id="load-input" v-model="selectedItem.location_lat" required></b-form-input>
							</b-form-group>
							<b-form-group label="Longitude" label-for="poles-input" label-cols="0" label-size="sm" label-align-sm="left">
								<b-form-input id="poles-input" v-model="selectedItem.location_lng" required></b-form-input>
							</b-form-group>
						</div>
						<div class="panel-new panel-new-5">
							<h4>Set Schedule  </h4>
							<b-row>

									<b-col>
										<b-form-group label="On Time" label-for="sched_ontime" label-cols="0" label-size="sm" label-align-sm="left">
											<b-form-input id="sched_ontime" v-model="selectedItem.on_time" required placeholder="HH:MM"></b-form-input>
										</b-form-group>					
									</b-col>
									<b-col>
										<b-form-group label="Off Time" label-for="sched_offtime" label-cols="0" label-size="sm" label-align-sm="left" >
												<b-form-input id="sched_offtime" v-model="selectedItem.off_time" required placeholder="HH:MM"></b-form-input>
											</b-form-group>
									</b-col>
							</b-row>
							
						
							
						</div>
					</b-col>
					</b-row>
				</b-container>
				<form ref="form" @submit.stop.prevent="handleSubmit">
					
				</form>
				<template v-slot:modal-footer="{ ok, close }">
					<b-button size="sm" variant="danger" @click="close()">Cancel</b-button>
					<b-button size="sm" variant="success" @click="ok()">{{(selectedItem.id > 0)?'Update':'Submit'}}</b-button>
				</template>
			</b-modal> 

			
		
		</b-container>
		<transition name="fade">
			<b-row v-if="loading" class="loading" style="position: absolute; top:0px; left:0px; right:0px; bottom:0px; z-index: 1000; background-color: rgba(0,0,0,0.4);" align-v="center" align-h="center">
				<b-spinner label="Busy" variant="light"></b-spinner>
			</b-row>
		</transition>
		</div>
	</div>
	
</template>
<script>
import Header from "@/components/Header.vue";
import { Line } from 'vue-chartjs';
export default {
	name: 'Devices',
	components: {
		"top-header": Header,
		"line-chart": Line,
	},
	mounted(){
		var userinfo = this.$session.get('user_info');
		if(userinfo.role != 1){
			this.fields.splice(6,1);
			this.fields.splice(4,1);
			this.fields.splice(3,1);
		}
		this.$refs.livechart.renderChart({
			labels: ['January', 'February', 'March', 'April', 'May', 'June'],
			datasets: [
				{
					label: ' CCMS CONNECTED',
					borderColor: '#000099',
					backgroundColor: '#99d6ff',
					data: [8275, 5025, 6520, 3562, 5862, 6357],
					fill: false,
					lineTension: 0,
				},
				{
					label: ' CCMS ON',
					borderColor: '#009900',
					backgroundColor: '#00ff04',
					data: [7514, 9652, 4578, 3562, 8562, 1457],
					fill: false,
					lineTension: 0,
				},
				{
					label: ' LOAD',
					borderColor: '#f79800',
					backgroundColor: '#ffb642',
					data: [5236, 5025, 2365, 3562, 5862, 6357],
					fill: false,
					lineTension: 0,
				}
			]},{
			responsive: true
		});
		this.loadzones()
		this.initload();
		this.nowTimes();
	},
	data() {
		var self = this;
		
		return{
			loading: true, 
			last_sync_time: '',
			zoneOptions: [],
			networkfilter: -1,
            powerfilter: -1,
            
            filter_state_id: '',
            filter_zone_id: '',
            filter_ulb_id: '',
			
			page_title: '',
			selectedUlb: self.$route.params.ulbareacode,
			zonesUrl: self.$session.get('apiurl')+'moradabadapi/zone-list',
			recordUrl: self.$session.get('apiurl')+'moradabadapi/device-all-janshi',
			insertUrl: self.$session.get('apiurl')+'moradabadapi/device-insert',
			updateUrl: self.$session.get('apiurl')+'moradabadapi/device-update',
			deleteUrl: self.$session.get('apiurl')+'moradabadapi/device-delete',
			maintenanceUrl: self.$session.get('apiurl')+'moradabadapi/device-maintenance',
			replaceUrl: self.$session.get('apiurl')+'moradabadapi/replacepanel-insert',
			nowTime: '',
			total_kwh: 0,
			device_on: 0,
			device_connected: 0,
			total_load: 0,
			current_load: 0,
			total_lights: 0,
			total_light_on: 0,
			total_light_off: 0,
			total_signal_loss: 0,
			filteredrecords: [],
			records: [],
			fields: [
				{ key: 'sno', label: 'S.No' },
				{ key: 'feeder_pillar_no', label: 'F. No.', sortable: true, class: 'text-center' },
				{ key: 'location', label: 'Location', sortable: true, class: 'text-left' },
				{ key: 'imei_no', label: 'IMEI', sortable: true, sortDirection: 'desc' },
				{ key: 'mobile_no', label: 'Mobile No', sortable: true, sortDirection: 'desc' },
				{ key: 'no_of_fittings', label: 'Fittings', sortable: false,	sortByFormatted: true, filterByFormatted: true },
				{ key: 'device_type', label: 'Type' },
				{ key: 'total_load', label: 'Total Load', class: 'text-right',
					formatter: (value) => { 
						return (value/1000).toFixed(3);
					},
				},
				{ key: 'total_kw', label: 'Actual Load', class: 'text-right',
					formatter: (value, key, item) => { 
						if(item.output_status == 0 && (parseInt(item.amp_r/1000) < self.$root.correction_amp || parseInt(item.amp_y/1000) < self.$root.correction_amp || parseInt(item.amp_b/1000) < self.$root.correction_amp)){
							value = 0;
						}
						return (value/100000).toFixed(3);
					},
				},
				{ key: 'supply', label: 'Power', class:"text-center", 
					formatter: (value, key, item) => {
						var supply = 'ON';
						if(item.datalength == 59){
							supply = 'OFF';
						}
						return supply;
					},
				},
				{ key: 'door_status', label: 'Door Status' },
				{ key: 'output_status', label: 'Output' , 
					formatter: (value) => {
						if(value == 0){
							return 'OFF';
						}
						return 'ON';
					},
				},
				{ key: 'update_time', label: 'TimeStamp', 
					formatter: (value, key, item) => {
						/*if(item.data_fault == 1){
							return self.$moment(item.fault_time).format('DD-MM-YYYY HH:mm:ss');
						}*/
						if(item.update_time == "" || item.update_time == "00-00-0000 00:00:00"){
							return '-n/a-';
						}
						return self.$moment(item.update_time).format('DD-MM-YYYY HH:mm:ss');
					},
				},
				{ key: 'connection_status', label: 'Network Status', sortable: true,
					formatter: (value, key, item) => {
						if(item.datalength != 59 && item.datalength != 210){
							return 2;
						}
						return value;
					}
				},
				{ key: 'maintenance', label: 'Mnt.', sortable: true },
				{ key: 'actions', label: 'Actions', class:'text-right', 'extra': 1 }
			],
			totalRows: 1,
			currentPage: 1,
			networkOptions: [{text:'All', value:-1}, {text:'Connected', value:1}, {text:'Disconnected', value:0}, {text:'Data Fault', value:2}],
			powerOptions: [{text:'All', value:-1}, {text:'ON', value:1}, {text:'OFF', value:0}, {text:'Power Failure', value:2}],
			pageOptions: [10, 20, 50, 100],
			perPage: 10,
			sortBy: '',
			sortDesc: false,
			sortDirection: 'asc',
			filter: null,
			filterOn: [],
			selectedItem: {},
			replaceItem: {},
			emptyItem: {
				id: 0,
				imei_no: '',
				zone_id: 0,
				state_id: 0,
				ulb_id: 0,
				feeder_pillar_no: '',
				ward_no: '',
				ccms_no: '',
				total_load: '',
				total_connection: 0,
				no_of_poles: 0,
				no_of_fittings: 0,
				location_lat: '',
				location_lng: '',
				led_18w: 0,
				led_24w: 0,
				led_35w: 0,
				led_45w: 0,
				led_70w: 0,
				led_75w: 0,
				led_110w: 0,
				led_140w: 0,
				led_190w: 0,
				maintenance: 0
			},
			center: { lat: 0, lng: 0 },
			markers: [],
			places: [],
			currentPlace: null,
			infoWindowPos: null,
			infoWindowOpen: false,
			currentMarkerIndex: null,
			zoneinfo: {},
			infoOptions: {
				content: '',
				pixelOffset: {
					width: 0,
					height: -35
				}
			},
		};
	},
	methods: {
		nowTimes(){
			this.timeFormate(new Date());
			setInterval(this.nowTimes, 1000);
		},
		timeFormate(timeStamp) {
			let year = new Date(timeStamp).getFullYear().toString().substr(-2);
			let month =new Date(timeStamp).getMonth() + 1 < 10? "0" + (new Date(timeStamp).getMonth() + 1): new Date(timeStamp).getMonth() + 1;
			let date =new Date(timeStamp).getDate() < 10? "0" + new Date(timeStamp).getDate(): new Date(timeStamp).getDate();
			let hh =new Date(timeStamp).getHours() < 10? "0" + new Date(timeStamp).getHours(): new Date(timeStamp).getHours();
			let mm =new Date(timeStamp).getMinutes() < 10? "0" + new Date(timeStamp).getMinutes(): new Date(timeStamp).getMinutes();
			let ss =new Date(timeStamp).getSeconds() < 10? "0" + new Date(timeStamp).getSeconds(): new Date(timeStamp).getSeconds();
			
			this.nowTime = date+""+month+""+year+""+hh+""+mm+""+ss;
		},
        filterZoneDevices: function (items) {
			var self = this;
			return items.filter(function (item) {
				if(item.parent ==0){
					return item.state  == self.filter_state_id;
				}
			})
		},
		filterULBDevices: function (items) {
			var self = this;
			return items.filter(function (item) {
				return item.parent == self.filter_zone_id && item.parent > 0;
			})
		},
		setRTC(mobile){
			this.sendSMS(mobile, "RTC,"+this.nowTime);
		},
		broadcastSMS(smstxt){
			var self = this;
			var mobiles = '';
            var url = 'http://sms.bmwebmedia.com/shn/api/pushsms.php?usr=624402&key=0105qJp302aRslvQCRCgLIpYL8meS0&sndr=RNDSMS&ph='+mobiles+'&text='+smstxt+'&rpt=1'
            self.axios.get(url, {
            })
            .then(function (response) {
					//console.log(response);
                    var msg = 'Message Sent!';
                    self.$bvToast.toast(msg, {
                        title: 'Delete',
                        toaster: 'b-toaster-bottom-right',
                        autoHideDelay: 5000,
                        variant: 'warning',
                        solid: true,
                        appendToast: true
                    });
					alert(response);
            })
            .catch(function (error) {
                alert(error);
            });
		},
        sendSMS(mobile, smstxt){
            var self = this;
            var url = 'http://sms.bmwebmedia.com/shn/api/pushsms.php?usr=624402&key=0105qJp302aRslvQCRCgLIpYL8meS0&sndr=RNDSMS&ph='+mobile+'&text='+smstxt+'&rpt=1'
            self.axios.get(url, {
                /*usr: '624402',
                key: '0105qJp302aRslvQCRCgLIpYL8meS0',
                sndr: 'TXTSMS',
                ph: mobile,
                text: smstxt,
                rpt: 1*/
            })
            .then(function (response) {
               // console.log(response);
                    var msg = 'Message Sent!';
                    self.$bvToast.toast(msg, {
                        title: 'Delete',
                        toaster: 'b-toaster-bottom-right',
                        autoHideDelay: 5000,
                        variant: 'warning',
                        solid: true,
                        appendToast: true
                    });
					alert(response);
            })
            .catch(function (error) {
                alert(error);
            });
        },
		onFilterDevices(){
			this.filteredrecords = this.filterDevices(this.records);
			this.totalRows = this.filteredrecords.length;
			this.currentPage = 1;
		},
		filterDevices(devices){
			var self = this;
			return devices.filter(function (d) {
				var valid = false;
				if(self.networkfilter < 0){
					//valid = true;
				}else if(self.networkfilter == 0){
					if(d.connection_status == 0 && d.datalength == 210){
						valid = true;
					}
				}else if(self.networkfilter == 1){
					if(d.connection_status == 1 && d.datalength == 210){
						valid = true;
					}
				}else if(self.networkfilter == 2){
					if(d.datalength != 59 && d.datalength != 210){
						valid = true;
					}
				}

				if(self.powerfilter < 0){
					//valid = true;
				}else if(self.powerfilter == 0){
					if(d.output_status == 0){
						valid = true;
					}
				}else if(self.powerfilter == 1){
					
					if(d.output_status == 1){
						valid = true;
					}
				}else if(self.powerfilter == 2){
					if(d.datalength == 59){
						valid = true;
					}
				}
				if(self.networkfilter < 0 && self.powerfilter< 0){
					valid = true;
				}
				if(valid){
					return d;
				}
			});
		},
		updateTotalLoad(){
			this.selectedItem.total_load = (parseInt(this.selectedItem.led_18w) * 18) + (parseInt(this.selectedItem.led_24w) * 24) + (parseInt(this.selectedItem.led_35w) * 35) + (parseInt(this.selectedItem.led_45w) * 45) + (parseInt(this.selectedItem.led_70w) * 70) + (parseInt(this.selectedItem.led_75w) * 75) + (parseInt(this.selectedItem.led_110w) * 110) + (parseInt(this.selectedItem.led_140w) * 140) + (parseInt(this.selectedItem.led_190w) * 190);

			this.selectedItem.no_of_fittings = parseInt(this.selectedItem.led_18w) + parseInt(this.selectedItem.led_24w) + parseInt(this.selectedItem.led_35w) + parseInt(this.selectedItem.led_45w) + parseInt(this.selectedItem.led_70w) + parseInt(this.selectedItem.led_75w) + parseInt(this.selectedItem.led_110w) + parseInt(this.selectedItem.led_140w) + parseInt(this.selectedItem.led_190w);
		},
		setMaintenance(val){
			var self = this;
			var maintenance_flag = -1;
			if(val.trigger == "maintenance_on"){
				maintenance_flag = 1;
			}
			else if(val.trigger == "maintenance_off"){
				maintenance_flag = 0;
			}

			if(maintenance_flag >= 0){
				var submitdata = new Object();
				submitdata.feeder_pillar_no = self.selectedItem.feeder_pillar_no;
				submitdata.maintenance = maintenance_flag;

				self.loading = true;
				//bvModalEvt.preventDefault();

				self.axios.post(self.maintenanceUrl, {
					accesskey: self.$session.get('access_key'),
					data: submitdata
				})
				.then(function (response) {
					if(response.data.error == 0 || response.data.error == '0'){
						self.$bvModal.hide('view-model');
						self.$bvToast.toast(response.data.message, {
							title: 'Status',
							toaster: 'b-toaster-bottom-right',
							autoHideDelay: 5000,
							variant: 'warning',
							solid: true,
							appendToast: true
						});
						self.initload();
					}
					
				})
				.catch(function (error) {
					alert(error);
				});
			}
		},
		toogleMarkerInfoWindow(marker, index){
			this.infoWindowPos = marker.position;
			this.infoOptions.content = marker.infotext;
			if(this.currentMarkerIndex == index){
				this.infoWindowOpen = !this.infoWindowOpen;
			}else{
				this.infoWindowOpen = true;
				this.currentMarkerIndex = index;
			}
		},
		addMarker(lat, lng, infotext, iconurl) {
			const marker = {
				lat: lat,
				lng: lng
			};
			this.markers.push({ position: marker, infotext: infotext, icon: {url:iconurl,size: {width: 35, height: 45, f: 'px', b: 'px'}, scaledSize: {width: 35, height: 45, f: 'px', b: 'px',}} });
			//this.markers.push({ position: marker, infotext: infotext, icon: {url:iconurl} });
			//this.places.push(this.currentPlace);
			this.center = marker;
			this.currentPlace = null;
		},
		addMarker2(lat, lng, infotext, iconurl) {
			const marker = {
				lat: lat,
				lng: lng
			};
			//this.markers.push({ position: marker, infotext: infotext, icon: {url:iconurl,size: {width: 60, height: 90, f: 'px', b: 'px'}, scaledSize: {width: 30, height: 45, f: 'px', b: 'px',}} });
			this.markers.push({ position: marker, infotext: infotext, icon: {url:iconurl} });
			//this.places.push(this.currentPlace);
			this.center = marker;
			this.currentPlace = null;
		},
		filterZone: function (items) {
			var self = this;
			return items.filter(function (item) {
				if(item.parent ==0){
					return item.state  == self.selectedItem.state_id;
				}
			})
		},
		filterULB: function (items) {
			var self = this;
			return items.filter(function (item) {
				return item.parent == self.selectedItem.zone_id && item.parent > 0;
			})
		},
		showAddModal(){
			var self = this;
			this.selectedItem = Object.assign({}, this.emptyItem);
			this.zoneOptions.forEach(function(field){
				if(field.areacode == self.selectedUlb){
					self.selectedItem.state_id = field.state;
					if(field.parent > 0){
						self.selectedItem.zone_id = field.parent;
					}
					if(field.parent > 0){
						self.selectedItem.ulb_id = field.id;
					}
				}
			});
			this.$root.$emit('bv::show::modal', 'edit-model');
		},
		showUpdateModal(item, index, button) {
			this.selectedItem = Object.assign({}, item);
			this.$root.$emit('bv::show::modal', 'edit-model', button)
        },
        showSMSModal(item, button){
            this.selectedItem = Object.assign({}, item);
			this.$root.$emit('bv::show::modal', 'sms-model', button);
        },
		showViewModal(item, button){
			this.selectedItem = Object.assign({}, item);
			this.$root.$emit('bv::show::modal', 'view-model', button);
		},
		showReplaceModal(item, button){
			this.replaceItem = {
				replace_imei_no: item.imei_no,
				replace_meter_no: item.device_no,
				feeder_pillar_no: item.feeder_pillar_no,
				new_imei_no: '',
				new_meter_no: '',
				mobile_no: item.mobile_no,
				replace_time: '',
			};
			this.$root.$emit('bv::show::modal', 'replace-model', button);
		},
		showDeleteModal(item){
			var self = this;
			this.$bvModal.msgBoxConfirm('Please confirm that you want to delete device.', {
				title: 'Please Confirm',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'YES',
				cancelTitle: 'NO',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if(value == true){
					self.axios.post(self.deleteUrl, {
						accesskey: self.$session.get('access_key'),
						deleteid: item.id
					})
					.then(function (response) {
						if(response.data.error == 0 || response.data.error == '0'){
							self.$bvToast.toast(response.data.message, {
								title: 'Delete',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'warning',
								solid: true,
								appendToast: true
							});
							self.initload();
						}
						
					})
					.catch(function (error) {
						alert(error);
					});
				}else{
					//alert('no '+item.id);
				}
			})
			.catch(err => {
				// An error occurred
				alert(err)
				//console.log(err);
			})
		},
		onReplaceDevice(bvModalEvt){
			var self = this;
			self.loading = true;
			bvModalEvt.preventDefault();
			
			self.axios.post(self.replaceUrl, {
				accesskey: self.$session.get('access_key'),
				data: self.replaceItem
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.$bvModal.hide('replace-model');
					self.$bvToast.toast(response.data.message, {
						title: 'Status',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'warning',
						solid: true,
						appendToast: true
					});
					self.initload();
				}
				
			})
			.catch(function (error) {
				alert(error);
			});
		},
		modalSubmit(bvModalEvt){
			var self = this;
			self.loading = true;
			bvModalEvt.preventDefault();
			var submitUrl = "";
			if(self.selectedItem.id == 0){
				submitUrl = self.insertUrl;
			}else{
				submitUrl = self.updateUrl;
			}
			
			self.axios.post(submitUrl, {
				accesskey: self.$session.get('access_key'),
				data: self.selectedItem
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.$bvModal.hide('edit-model');
					self.$bvToast.toast(response.data.message, {
						title: 'Status',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'warning',
						solid: true,
						appendToast: true
					});
					self.initload();
				}
			})
			.catch(function (error) {
				alert(error);
			});
		},
		
		

		resetSelectedItem(){
			var self = this;
			self.selectedItem = Object.assign({}, self.emptyItem);
		},
		loadzones(){
			var self = this;
			
			self.axios.post(self.zonesUrl, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.zoneOptions = response.data.result;
					self.zoneOptions.forEach(function(field){
						if(field.state == 'in-mh'){
							if(field.areacode == self.selectedUlb){
								self.zoneOptions.forEach(function(field2){
									if(field2.id == field.parent){
										self.page_title = field.title;//+', '+field2.title+', Maharastra';
									}
								});
								//self.page_title = field.title+', Maharastra';
							}
						}
					});
				}
			})
			.catch(function (error) {
				alert(error);
			});
		},
		initload(){
			var self = this;
			
			self.axios.post(self.recordUrl, {
				accesskey: self.$session.get('access_key'),
                state_id: self.filter_state_id,
                zone_id: self.filter_zone_id,
                ulb_id: self.filter_ulb_id
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.records = response.data.result.ulb_devices;
					self.zoneinfo = response.data.result.zoneinfo;
					self.loading = false;
					self.totalRows = self.records.length;

					self.last_sync_time = self.$moment().format('DD-MM-YYYY HH:mm:ss');

					self.total_lights = 0;
					self.total_light_on = 0;
					self.total_light_off = 0;
					self.total_signal_loss = 0;

					self.current_load = 0;
					self.total_load = 0;

					self.total_kwh = 0;

					self.device_on = 0;
					self.device_connected = 0;
					var sno = 1;
					self.records.forEach(function(field){
						field.sno = sno++;

						self.total_lights += field.no_of_fittings;
						
						self.total_load += parseInt(field.total_load);

						if(field.kwh && field.kwh != 'NaN'){
							self.total_kwh += parseInt(field.kwh);
						}

						//console.log(field.output_status+" "+(field.amp_r/1000)+" "+(field.amp_y/1000)+" "+(field.amp_b/1000));
						if(field.output_status == 0 && (parseInt(field.amp_r/1000) < self.$root.correction_amp || parseInt(field.amp_y/1000) < self.$root.correction_amp || parseInt(field.amp_b/1000) < self.$root.correction_amp)){
							// do nothing
						}else{
							if(field.total_kw && field.total_kw != 'NaN') self.current_load += parseInt(field.total_kw);
						}

						var curdatetime = self.$moment(); // i will replace this with server time by passing time in api
						var conn_status = 1;
						var dbdatetime = '';
						var duration = '';
						var minutes = '';
						if(field.data_fault == 1){
							dbdatetime = self.$moment(field.fault_time);
							
							if(curdatetime > dbdatetime){
								duration = self.$moment.duration(curdatetime.diff(dbdatetime));
							}else{
								duration = self.$moment.duration(dbdatetime.diff(curdatetime));
							}
							minutes = duration.asMinutes();
							
							if(minutes < self.$root.disconnection_time){
								conn_status = 1;
							}else{
								conn_status = 0;
							}
						}
						else if(field.update_time != ""){
							dbdatetime = self.$moment(field.update_time);
							
							if(curdatetime > dbdatetime){
								duration = self.$moment.duration(curdatetime.diff(dbdatetime));
							}else{
								duration = self.$moment.duration(dbdatetime.diff(curdatetime));
							}
							minutes = duration.asMinutes();
							
							if(minutes < self.$root.disconnection_time){
								conn_status = 1;
							}else{
								conn_status = 0;
							}
						}else{
							conn_status = 0;
						}
						field.connection_status = conn_status;
						if(conn_status == 1){
							self.device_connected += 1;
						}
						if(field.output_status == 1 && conn_status == 1){
							self.device_on += 1;
							self.total_light_on += field.no_of_fittings;
						}
						if(field.output_status == 0 && conn_status == 1){
							self.total_light_off += field.no_of_fittings;
						}
						if(conn_status == 0){
							self.total_signal_loss += field.no_of_fittings;
						}
					});

					self.filteredrecords = self.filterDevices(self.records);
					

					var min_lat = 100;
					var min_lng = 100;
					var max_lat = 0;
					var max_lng = 0;

					self.markers = [];

					//if(self.markers.length == 0 || self.records.length != self.markers.length){
						for (var i = 0; i < self.records.length; i++) {
							var d = self.records[i];

							var actual_load = 0;
							if(parseInt(d.total_kw/100000) > 0.5){
								actual_load = (d.total_kw/100000).toFixed(3);
							}

							var msg = '<b>CCMS ID: '+d.feeder_pillar_no+'</b><br><b>Location</b> : '+d.location+'<br><b>Latitude :</b> '+d.location_lat+'<br><b>Longitude :</b> '+d.location_lng+'<br><b>Total Lamps Connected :</b> '+d.no_of_fittings+'<br><b>Actual Load KW :</b> '+actual_load+'<br><b>Last Updated Time :</b> '+self.$moment(d.update_time).format('DD-MM-YYYY HH:mm:ss');

							min_lat = Math.min(d.location_lat, min_lat);
							min_lng = Math.min(d.location_lng, min_lng);

							max_lat = Math.max(d.location_lat, max_lat);
							max_lng = Math.max(d.location_lng, max_lng);

						//	console.log(min_lat+" "+min_lng+" "+max_lat+" "+max_lng);

						//	var color = 'blue';
							var blueurl = "https://www.fablurs.com/flag-blue.svg";//http://maps.gstatic.com/mapfiles/markers2/boost-marker-mapview.png";
							var redurl = "https://www.fablurs.com/flag-red.svg";
							var greenurl = "https://www.fablurs.com/flag-green.svg";
							var iconurl = blueurl;
							if(d.connection_status == 1){
								if(d.output_status == 1){
									iconurl = greenurl;
								}else{
									iconurl = redurl;
								}
							}
							
							//alert(iconurl);
							self.addMarker(self.records[i].location_lat, self.records[i].location_lng, msg, iconurl);

							/*blueurl = "http://maps.gstatic.com/mapfiles/markers2/boost-marker-mapview.png";
							redurl = "http://maps.gstatic.com/mapfiles/markers2/marker.png";
							greenurl = "http://maps.gstatic.com/mapfiles/markers2/icon_green.png";
							iconurl = blueurl;
							if(d.connection_status == 1){
								if(d.output_status == 1){
									iconurl = greenurl;
								}else{
									iconurl = redurl;
								}
							}
							
							//alert(iconurl);
							self.addMarker2(self.records[i].location_lat, self.records[i].location_lng, msg, iconurl);*/
						}
						self.center = { lat: min_lat + (max_lat - min_lat)/2, lng: min_lng + (max_lng - min_lng)/2 };
					//}
					setTimeout(self.initload, parseInt(self.$root.reload_duration) * 4);
				}else{
					self.$root.forceLogout(response.data.message);
				}
				
			})
			.catch(function (error) {
				alert(error);
			});
			//alert('login '+self.email+" "+self.password);
		},
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
		},
		downloadcsv(){
			var self = this;
			var header = new Array()
			self.fields.forEach(function(item){
				if(!item.extra){
					header.push(item.label);
				}
			});
			
			//var d = table.rows().data();
			var finalarr = new Array();
			finalarr.push(header);
			self.records.forEach(function(row){
				var dataarr = new Array();
				self.fields.forEach(function(field){
					if(field.key != 'extra'){
						dataarr.push(row[field.key]);
					}
				});
				finalarr.push(dataarr);
			});
			
			let csvContent = "data:text/csv;charset=utf-8," 
			+ finalarr.map(e => e.join(",")).join("\n");

			var encodedUri = encodeURI(csvContent);
			var link = document.createElement("a");
			link.setAttribute("href", encodedUri);
			link.setAttribute("download", "device_report.csv");
			document.body.appendChild(link); // Required for FF

			link.click();
		}
	}
}
</script>
<style>
html{
	min-height: 100%;
}
/* body{
	background-color: '#FFF' !important;
	background-image: none !important;
} */
body{
	background-image: url(../assets/home-banner.png) !important;
	background-repeat: no-repeat;
	background-size: cover;
	/* background-position: center center; */
	background-position: bottom;
   
}
.table{
	font-size: small;
}
.table .btn{
	font-size: 12px;
	font-weight: 600;
}
.table td, .table th{
	vertical-align: middle;
}


.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to{
  opacity: 0;
}
.header-title{
	padding: 0.3rem 1.25rem;
}

.badge{
	font-size: 85%;
}

.text-sm{
	font-size: 13px;
}
.text-md{
	font-size: 16px;
}
.text-lg{
	font-size: 18px;
}

.cont-box {
   
   backdrop-filter: blur(10px);
   -webkit-backdrop-filter: blur(16px);
   height: auto;   
   background: transparent; 
   margin: 23px;
}

</style>